import type { PartialCrmMessages } from "./englishCrmMessages";

export const russianCrmMessages: PartialCrmMessages = {
  resources: {
    companies: {
      name: "Компания |||| Компании",
      forcedCaseName: "Компания",

      fields: {
        name: "Название компании",
        website: "Сайт",
        linkedin_url: "LinkedIn",
        phone_number: "Телефон",
        created_at: "Дата создания",
        nb_contacts: "Количество контактов",
        revenue: "Выручка",
        sector: "Сфера деятельности",
        size: "Размер компании",
        tax_identifier: "ИНН",
        address: "Адрес",
        city: "Город",
        zipcode: "Индекс",
        state_abbr: "Регион",
        country: "Страна",
        description: "Описание",
        context_links: "Ссылки",
        sales_id: "Ответственный",
      },

      empty: {
        description: "Список компаний пока пуст.",
        title: "Компании не найдены",
      },

      import: {
        title: "Импорт компаний",
      },

      field_categories: {
        contact: "Контакты",
        additional_info: "Дополнительная информация",
        address: "Адрес",
        context: "Контекст",
      },

      action: {
        create: "Создать компанию",
        edit: "Редактировать компанию",
        new: "Новая компания",
        show: "Открыть компанию",
      },

      added_on: "Добавлено %{date}",
      followed_by: "Ответственный: %{name}",
      followed_by_you: "Вы ответственный",
      no_contacts: "Нет контактов",

      nb_contacts:
        "%{smart_count} контакт |||| %{smart_count} контакта |||| %{smart_count} контактов",

      nb_deals:
        "%{smart_count} сделка |||| %{smart_count} сделки |||| %{smart_count} сделок",

      sizes: {
        one_employee: "1 сотрудник",
        two_to_nine_employees: "2–9 сотрудников",
        ten_to_forty_nine_employees: "10–49 сотрудников",
        fifty_to_two_hundred_forty_nine_employees: "50–249 сотрудников",
        two_hundred_fifty_or_more_employees: "250 и более сотрудников",
      },

      autocomplete: {
        create_error: "Не удалось создать компанию",
        create_item: "Создать %{item}",
        create_label: "Начните вводить название новой компании",
      },
    },

    contacts: {
      name: "Контакт |||| Контакты",
      forcedCaseName: "Контакт",

      field_categories: {
        background_info: "Дополнительная информация",
        identity: "Основное",
        misc: "Дополнительно",
        personal_info: "Контактные данные",
        position: "Должность",
      },

      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        last_seen: "Последняя активность",
        title: "Должность",
        company_id: "Компания",
        email_jsonb: "Email",
        email: "Email",
        phone_jsonb: "Телефоны",
        phone_number: "Телефон",
        linkedin_url: "LinkedIn",
        background: "Дополнительная информация",
        has_newsletter: "Получает рассылку",
        sales_id: "Ответственный",
      },

      action: {
        add: "Добавить контакт",
        add_first: "Добавить первый контакт",
        create: "Создать контакт",
        edit: "Редактировать контакт",
        export_vcard: "Экспортировать vCard",
        new: "Новый контакт",
        show: "Открыть контакт",
      },

      background: {
        last_activity_on: "Последняя активность: %{date}",
        added_on: "Добавлено %{date}",
        followed_by: "Ответственный: %{name}",
        followed_by_you: "Вы ответственный",
        status_none: "Нет",
      },

      position_at: "%{title},",
      position_at_company: "%{title}, %{company}",

      empty: {
        description: "Список контактов пока пуст.",
        title: "Контакты не найдены",
      },

      import: {
        title: "Импорт контактов",
      },

      inputs: {
        genders: {
          male: "Он",
          female: "Она",
          nonbinary: "Они",
        },

        personal_info_types: {
          work: "Рабочий",
          home: "Личный",
          other: "Другой",
        },
      },

      list: {
        error_loading: "Не удалось загрузить контакты",
      },

      bulk_tag: {
        action: "Добавить тег",
        back: "Назад к тегам",
        create_description:
          "Создайте новый тег и примените его к выбранным контактам.",
        description:
          "Выберите существующий тег или создайте новый для выбранных контактов.",
        empty: "Тегов пока нет. Создайте первый тег.",
        error: "Не удалось добавить тег",
        noop: "У выбранных контактов уже есть этот тег",
        success:
          "Тег добавлен к %{smart_count} контакту |||| Тег добавлен к %{smart_count} контактам",
        title: "Добавить тег контактам",
      },

      merge: {
        action: "Объединить с другим контактом",
        confirm: "Объединить контакты",
        current_contact: "Текущий контакт будет удалён",
        description: "Объединить этот контакт с другим.",
        error: "Не удалось объединить контакты",
        merging: "Объединение...",
        no_additional_data: "Нет дополнительных данных для объединения",
        select_target: "Выберите контакт для объединения",
        success: "Контакты успешно объединены",
        target_contact: "Этот контакт будет сохранён",
        title: "Объединение контактов",
        warning_description:
          "Все данные будут перенесены во второй контакт. Это действие нельзя отменить.",
        warning_title: "Внимание",
        what_will_be_merged: "Будут объединены:",
      },

      filters: {
        before_last_month: "До прошлого месяца",
        before_this_month: "До текущего месяца",
        before_this_week: "До этой недели",
        managed_by_me: "Только мои",
        search: "Поиск по имени, компании...",
        this_week: "На этой неделе",
        today: "Сегодня",
        tags: "Теги",
        tasks: "Календарь",
      },

      hot: {
        empty_change_status:
          "Чтобы изменить статус контакта, добавьте заметку и откройте дополнительные параметры.",
        empty_hint: "Здесь появятся контакты со статусом «Горячий».",
        title: "Горячие контакты",
      },
    },

    deals: {
      name: "Сделка |||| Сделки",

      fields: {
        name: "Название проекта",
        description: "Описание",
        company_id: "Компания",
        contact_ids: "Контакты",
        category: "Тип работ / изделия",
        amount: "Стоимость КП",
        expected_closing_date: "Плановый срок завершения",
        stage: "Этап",
      },

      action: {
        back_to_deal: "Назад к проекту",
        create: "Создать проект",
        new: "Новый проект",
      },

      field_categories: {
        misc: "Дополнительно",
      },

      filters: {
        only_mine: "Только мои проекты",
      },

      archived: {
        action: "В архив",
        error: "Не удалось архивировать проект",
        list_title: "Архив проектов",
        success: "Проект архивирован",
        title: "Архивный проект",
        view: "Открыть архив",
      },

      inputs: {
        linked_to: "Связано с",
      },

      unarchived: {
        action: "Вернуть на доску",
        error: "Не удалось вернуть проект",
        success: "Проект возвращён",
      },

      updated: "Проект обновлён",

      empty: {
        before_create: "перед созданием проекта.",
        description: "Список проектов пока пуст.",
        title: "Проекты не найдены",
      },

      import: {
        title: "Импорт проектов",
      },

      invalid_date: "Некорректная дата",
    },

    notes: {
      name: "Заметка |||| Заметки",
      forcedCaseName: "Заметка",

      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Вложения",
        contact_id: "Контакт",
        deal_id: "Сделка",
      },

      action: {
        add: "Добавить заметку",
        add_first: "Добавить первую заметку",
        delete: "Удалить заметку",
        edit: "Редактировать заметку",
        update: "Обновить заметку",
        add_this: "Добавить заметку",
      },

      sheet: {
        create: "Создать заметку",
        create_for: "Создать заметку для %{name}",
        edit: "Редактировать заметку",
        edit_for: "Редактировать заметку для %{name}",
      },

      deleted: "Заметка удалена",
      empty: "Заметок пока нет",
      author_added: "%{name} добавил заметку",
      you_added: "Вы добавили заметку",
      me: "Я",

      list: {
        error_loading: "Не удалось загрузить заметки",
      },

      note_for_contact: "Заметка для %{name}",

      stepper: {
        hint: "Откройте карточку контакта и добавьте заметку",
      },

      added: "Заметка добавлена",

      inputs: {
        add_note: "Добавить заметку",
        options_hint: "(вложения и дополнительные параметры)",
        show_options: "Показать параметры",
      },

      actions: {
        attach_document: "Прикрепить документ",
      },

      validation: {
        note_or_attachment_required: "Добавьте текст заметки или вложение",
      },
    },

    sales: {
      name: "Пользователь |||| Пользователи",

      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Email",
        secondary_email: "Дополнительный email",
        secondary_emails: "Дополнительные email",
        administrator: "Администратор",
        disabled: "Отключён",
      },

      create: {
        error: "Не удалось создать пользователя.",
        success:
          "Пользователь создан. Ему будет отправлено письмо для установки пароля.",
        title: "Создать пользователя",
      },

      edit: {
        error: "Произошла ошибка. Попробуйте ещё раз.",
        record_not_found: "Пользователь не найден",
        success: "Пользователь обновлён",
        title: "Редактировать %{name}",
      },

      action: {
        new: "Новый пользователь",
      },
    },

    tasks: {
      name: "Задача |||| Задачи",
      forcedCaseName: "Задача",

      fields: {
        text: "Описание",
        due_date: "Срок",
        type: "Тип",
        contact_id: "Контакт",
        due_short: "до",
      },

      action: {
        add: "Добавить задачу",
        create: "Создать задачу",
        edit: "Редактировать задачу",
      },

      actions: {
        postpone_next_week: "Перенести на следующую неделю",
        postpone_tomorrow: "Перенести на завтра",
        title: "Действия с задачей",
      },

      added: "Задача добавлена",
      deleted: "Задача удалена",

      dialog: {
        create: "Создать задачу",
        create_for: "Создать задачу для %{name}",
      },

      sheet: {
        edit: "Редактировать задачу",
        edit_for: "Редактировать задачу для %{name}",
      },

      empty: "Задач пока нет",

      empty_list_hint:
        "Задачи, добавленные к контактам, будут отображаться здесь.",

      filters: {
        later: "Позже",
        overdue: "Просрочено",
        this_week: "На этой неделе",
        today: "Сегодня",
        tomorrow: "Завтра",
        with_pending: "Есть активные задачи",
      },

      regarding_contact: "Контакт: %{name}",
      updated: "Задача обновлена",
    },

    tags: {
      name: "Тег |||| Теги",

      action: {
        add: "Добавить тег",
        create: "Создать тег",
      },

      dialog: {
        color: "Цвет",
        create_title: "Создать тег",
        edit_title: "Редактировать тег",
        name_label: "Название тега",
        name_placeholder: "Введите название",
      },

      empty: "Тегов пока нет.",
    },
  },

  crm: {
    action: {
      reset_password: "Сбросить пароль",
    },

    auth: {
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Подтвердите пароль",

      confirmation_required:
        "Мы отправили письмо со ссылкой для подтверждения аккаунта.",

      recovery_email_sent:
        "Если такой пользователь существует, на его email будет отправлено письмо для восстановления пароля.",

      sign_in_failed: "Не удалось войти.",

      sign_in_google_workspace: "Войти через Google Workspace",

      signup: {
        create_account: "Создать аккаунт",
        create_first_user:
          "Создайте первого пользователя для завершения настройки.",
        creating: "Создание...",
        initial_user_created: "Первый пользователь успешно создан",
      },

      welcome_title: "Добро пожаловать в Rovero CRM",
    },

    common: {
      account_manager: "Ответственный",
      activity: "Активность",
      added: "добавлено",
      details: "Подробнее",
      last_activity_with_date: "последняя активность %{date}",
      load_more: "Показать ещё",
      misc: "Дополнительно",
      past: "Прошедшие",
      read_more: "Подробнее",
      retry: "Повторить",
      show_less: "Свернуть",
      copied: "Скопировано",
      copy: "Копировать",
      loading: "Загрузка...",
      me: "Я",

      task_count:
        "%{smart_count} задача |||| %{smart_count} задачи |||| %{smart_count} задач",
    },

    changelog: {
      title: "История обновлений",
    },

    activity: {
      added_company: "%{name} добавил компанию",
      you_added_company: "Вы добавили компанию",

      added_contact: "%{name} добавил контакт",
      you_added_contact: "Вы добавили контакт",

      added_note: "%{name} добавил заметку о",
      you_added_note: "Вы добавили заметку о",

      added_note_about_deal: "%{name} добавил заметку о сделке",

      you_added_note_about_deal: "Вы добавили заметку о сделке",

      added_deal: "%{name} добавил сделку",
      you_added_deal: "Вы добавили сделку",

      at_company: "в компании",
      to: "к",
      load_more: "Показать ещё",
    },

    dashboard: {
      deals_chart: "Планируемая выручка",
      deals_pipeline: "Воронка сделок",
      latest_activity: "Последняя активность",

      latest_activity_error: "Не удалось загрузить активность",

      latest_notes: "Мои последние заметки",

      latest_notes_added_ago: "добавлено %{timeAgo}",

      stepper: {
        install: "Настройка Rovero CRM",
        progress: "%{step}/3 выполнено",
        whats_next: "Что дальше?",
      },

      upcoming_tasks: "Ближайшие задачи",
    },

    data_import: {
      button: "Импорт CSV",

      complete:
        "Импорт завершён. Импортировано: %{importCount}, ошибок: %{errorCount}",

      csv_file: "CSV-файл",

      error: "Не удалось импортировать файл. Проверьте корректность CSV.",

      in_progress: "Выполняется импорт…",

      progress:
        "Импортировано %{importCount} из %{rowCount}. Ошибок: %{errorCount}.",

      remaining_time: "Осталось примерно:",
      resource: "Раздел",
      sample_download: "Скачать пример CSV",
      sample_hint: "Используйте этот CSV-файл как шаблон",
      start: "Начать импорт",
      stop: "Остановить",

      stopped:
        "Импорт остановлен. Импортировано: %{importCount}, ошибок: %{errorCount}",

      title: "Импорт данных",
    },

    header: {
      import_data: "Импорт из JSON",
    },

    image_editor: {
      change: "Изменить",

      drop_hint: "Перетащите файл сюда или нажмите, чтобы выбрать.",

      editable_content: "Редактируемое изображение",
      title: "Загрузка и изменение изображения",
      update_image: "Обновить изображение",
    },

    import: {
      action: {
        download_error_report: "Скачать отчёт об ошибках",

        import: "Импортировать",
        import_another: "Импортировать другой файл",
      },

      error: {
        unable: "Не удалось импортировать этот файл.",
      },

      idle: {
        description_1:
          "Можно импортировать пользователей, компании, контакты, заметки и задачи.",

        description_2:
          "Данные должны находиться в JSON-файле следующего формата:",
      },

      status: {
        all_success: "Все записи успешно импортированы.",

        complete: "Импорт завершён.",
        failed: "Ошибка",
        imported: "Импортировано",

        in_progress: "Выполняется импорт. Не закрывайте страницу.",

        some_failed: "Некоторые записи не удалось импортировать.",

        table_caption: "Статус импорта",
      },

      title: "Импорт из JSON",
    },

    settings: {
      about: "О системе",

      companies: {
        sectors: "Сферы деятельности",
      },

      dark_mode_logo: "Логотип для тёмной темы",

      deals: {
        categories: "Категории",
        currency: "Валюта",

        pipeline_help:
          "Выберите этапы сделок, которые относятся к активной воронке.",

        pipeline_statuses: "Этапы воронки",
        stages: "Этапы",
      },

      light_mode_logo: "Логотип для светлой темы",

      notes: {
        statuses: "Статусы",
      },

      reset_defaults: "Восстановить стандартные настройки",

      save_error: "Не удалось сохранить настройки",

      saved: "Настройки сохранены",
      saving: "Сохранение...",

      tasks: {
        types: "Типы задач",
      },

      preferences: "Предпочтения",
      title: "Настройки",
      app_title: "Название приложения",

      sections: {
        branding: "Брендинг",
      },

      validation: {
        duplicate: "Повторяющееся значение %{display_name}: %{items}",

        in_use:
          "Нельзя удалить %{display_name}, пока значение используется в сделках: %{items}",

        validating: "Проверка…",

        entities: {
          categories: "категории",
          stages: "этапы",
        },
      },
    },

    theme: {
      dark: "Тёмная",
      label: "Тема",
      light: "Светлая",
      system: "Системная",
    },

    language: "Язык",

    navigation: {
      label: "Навигация CRM",
    },

    profile: {
      add_secondary_email: "Добавить email",

      email_taken: "%{email} уже используется другим пользователем",

      no_secondary_emails: "Нет",

      secondary_email_invalid: "%{email} имеет некорректный формат",

      secondary_email_is_primary: "%{email} уже является основным адресом",

      secondary_email_taken: "%{email} уже используется другим пользователем",

      too_many_secondary_emails:
        "Можно добавить не более 10 дополнительных email",

      secondary_emails_help: "Другие адреса, с которых вы отправляете письма.",

      inbound: {
        description:
          "Вы можете отправлять письма на входящий адрес CRM. Rovero CRM обработает их и добавит заметки к соответствующим контактам.",

        title: "Входящая почта",
      },

      mcp: {
        title: "MCP-сервер",

        description:
          "Используйте этот URL для подключения AI-ассистента к данным CRM через Model Context Protocol (MCP).",
      },

      password: {
        change: "Изменить пароль",
      },

      password_reset_sent: "Письмо для сброса пароля отправлено на ваш email",

      record_not_found: "Пользователь не найден",

      title: "Профиль",

      updated: "Профиль обновлён",

      update_error: "Произошла ошибка. Попробуйте ещё раз.",
    },

    validation: {
      invalid_url: "Введите корректный URL",

      invalid_linkedin_url: "Ссылка должна вести на linkedin.com",
    },
  },
};
